import Vue from 'vue';
import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from '@/mixins/HttpMixin';
import {LogisticNeedsItem} from '@/interfaces/LogisticNeedsItem';
import {HTTP} from "@/utils/httpCommonUtil";

export default Vue.component('logistics-needs-card', {
  name: 'LogisticNeedsCard',
  props: {
    'shiftId': { type: Number },
  },
  data () {
    return {
      cardExpanded: false,
      logisticNeedsItems: [] as LogisticNeedsItem[],
      travelTaskId: 0 as number,
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner
  },
  mixins: [ HttpMixin ],
  computed: {
    remainingCount(): number {
      return this.logisticNeedsItems.map(item => item.isCompleted || !item.isActive ? 0 : 1).reduce((a: number, b: number) => a + b, 0);
    },
    countTravelItems: function () {
      if (this.logisticNeedsItems) {
        return this.logisticNeedsItems.reduce((acc, item) => {
          if (item.checklistId && item.isActive) {
            return acc+1;
          }
          return acc;
        }, 0);
      }
      return 0;
    },
    countCompleteTravelItems: function () {
      if (this.logisticNeedsItems) {
        return this.logisticNeedsItems.reduce((acc, item) => {
          if (item.checklistId && item.isActive && item.isCompleted) {
            return acc+1;
          }
          return acc;
        }, 0);
      }
      return 0;
    }
  },
  async created() {
    await this.expandCard();
  },
  methods: {
    async expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.getLogisticsItems();
      }
    },

    async getLogisticsItems() {
      let self = this as any;
      this.logisticNeedsItems = [];
      self.travelTaskId = 0;
      const checklistItemsOptions = ["Flight", "Rental Car", "Hotel"];
      const nonTravelTasksOptions = ["Credentials", "Licensing"];
      return HTTP.get('api/shift-logistics/get-logistics-tasks-for-shift/' + this.$route.params.shiftId)
        .then(function (response: any) {
          checklistItemsOptions.forEach(function (checklistOption) {
            const existing = response.data.data.checklistItems.find((item: any) => item.title === checklistOption);
            if (self.travelTaskId === 0) {
              self.travelTaskId = existing ? Math.max.apply(Math, response.data.data.checklistItems.map((o: any) => o.taskId)) : 0;
            }
            const checklistItem = {
              checklistId: existing ? existing.checklistId : null,
              taskId: existing ? existing.taskId : null,
              isCompleted: existing ? existing.isComplete : null,
              title: existing ? existing.title : checklistOption,
              description: existing ? existing.description : null,
              isActive: Boolean(existing)
            }
            self.logisticNeedsItems.push(checklistItem);
          })
          nonTravelTasksOptions.forEach(function (taskOption) {
            const existing = response.data.data.tasks.find((item: any) => item.taskTypeName === taskOption);
            const task = {
              checklistId: existing ? existing.checklistId : null,
              taskId: existing ? existing.taskId : null,
              isCompleted: existing ? existing.isComplete : null,
              title: existing ? existing.taskTypeName : taskOption,
              description: existing ? existing.description : null,
              isActive: Boolean(existing)
            }
            self.logisticNeedsItems.push(task);
          })
        }).catch(function (err: any) {
          console.log('response Error!');
          console.log(err);
        })
    },
    async createChecklistItem(taskId: number, title: string) {
      try {
        await HTTP.post('api/shift-logistics/create-checklist-item/', {
          taskId,
          title,
        })
        return this.getLogisticsItems();
      } catch (err) {
        console.log('response Error!');
        console.log(err);
      }
    },
    deleteChecklistItem(item: LogisticNeedsItem) {
      return HTTP.post('api/shift-logistics/delete-checklist-item/', {item})
        .then((response: any) => {
          return this.getLogisticsItems();
        })
        .catch(function (err: any) {
          console.log('response Error!');
          console.log(err);
        })
    },

    async createTask(credentialsTask: any, licensingTask: any, travelTask: any ): Promise<void> {
      return HTTP.post('api/shift-logistics/', {
        credentials: credentialsTask ? [credentialsTask] : null,
        licensing: licensingTask ? [licensingTask] : null,
        travel: travelTask
      }).then(async (response: any) => {
        await this.getLogisticsItems();
      }).catch(function (err: any) {
        console.log('response Error!');
        console.log(err);
      })
    },

    async toggleArchiveTask(taskId: number): Promise<void>{
      return HTTP.put('api/shift-logistics/archive-task/' + taskId)
        .then(async (response: any) => {
          await this.getLogisticsItems();
        })
        .catch(function (err: any) {
          console.log('response Error!');
          console.log(err);
        })
    },

    async toggleCompleteTask(taskId: number) {
      return HTTP.put('api/shift-logistics/complete-task/' + taskId)
        .then((response: any) => {
          return this.getLogisticsItems();
        })
        .catch(function (err: any) {
          console.log('response Error!');
          console.log(err);
        })
    },

    async toggleCompleted(item: LogisticNeedsItem) {
      if (item.title === "Licensing" || item.title === "Credentials") {
        await this.toggleCompleteTask(item.taskId);
        return
      } else if (item.isCompleted && (this.countTravelItems === this.countCompleteTravelItems)) {
        await this.toggleCompleteTask(item.taskId);
      } else if (!item.isCompleted && (this.countTravelItems === this.countCompleteTravelItems+1)) {
        await this.toggleCompleteTask(item.taskId);
      }
      return HTTP.put('api/shift-logistics/complete-checklist-item/' + item.checklistId)
        .then((response: any) => {
          return this.getLogisticsItems();
        })
        .catch(function (err: any) {
          console.log('response Error!');
          console.log(err);
        })
    },

    async toggleArchive(item: LogisticNeedsItem) {
      this.logisticNeedsItems = this.logisticNeedsItems.map(item => item);
      let self = this;
      if (item.isActive) {
        if (item.title === "Flight" || item.title === "Rental Car" || item.title === "Hotel") {
          if (this.countTravelItems > 0) {
            await this.createChecklistItem(self.travelTaskId, item.title);
          } else {
            const travelTask = {
              flight: item.title === "Flight",
              carRental: item.title === "Rental Car",
              hotel: item.title === "Hotel",
              shiftIds: [self.shiftId]
            }
            await this.createTask(null, null, travelTask);
          }
        } else {
          const emptyTravel = {
            flight: false,
            carRental: false,
            hotel: false,
            shiftIds: null
          }
          if (item.title === "Licensing") {
            await this.createTask(null, this.shiftId, emptyTravel);
          }
          if (item.title === "Credentials") {
            await this.createTask(this.shiftId, null, emptyTravel);
          }
        }
      } else if (item.checklistId) {
        if (this.countTravelItems === this.countCompleteTravelItems && this.countCompleteTravelItems !== 0){
          await this.toggleCompleteTask(self.travelTaskId);
        }
        await this.deleteChecklistItem(item);
        if (this.countTravelItems === 0) {
          await this.toggleArchiveTask(item.taskId);
        }
      } else await this.toggleArchiveTask(item.taskId);
    },
  }
})



// WEBPACK FOOTER //
// ./src/components/shift/cards/logisticNeeds/logisticNeedsCard.ts